import { PrintUtilsBase, RotateCameraType, StateTypes, TempDataToRestore, ViewType } from "@ortho-next/nextray-core";
import { Vector2 } from "three";
import { MultiViewsElementCustom } from "../Controls/MultiViewsElementCustom";
import { Main } from "../Core/Main";
import { bindedModel } from "../Models/BindedModel";
import { Context } from "../States/Context";
import { PrintStateTypes } from "../States/State";

export type ViewPlanImages = { deformity: string, templating: string; };

/**
 * Generates ViewPlan images.
 */
export class ViewPlanUtils extends PrintUtilsBase {
	protected declare _main: Main;
	protected declare _context: Context;

	constructor(main: Main, context: Context) {
		super(main, context);
	}

	public generateImages(stateType: StateTypes, resolution: Vector2): ViewPlanImages {
		const printResult: ViewPlanImages = { deformity: "", templating: "" };
		const tempData: TempDataToRestore = {};
		const renderMultipleView = this._main.hasAP && this._main.hasLT;

		this.getRestoreData(tempData);

		if (renderMultipleView) {
			this._main.multiViewsActive = true;
		}

		this.applyResize(resolution.x, resolution.y);
		this._main.renderer.setPixelRatio(1);

		if (renderMultipleView) {
			(this._main.multiviewRenderer.viewsports[ViewType.AP] as MultiViewsElementCustom).cameraControls.fitToPlane();
			(this._main.multiviewRenderer.viewsports[ViewType.LT] as MultiViewsElementCustom).cameraControls.fitToPlane();
		} else {
			if (this._main.hasAP) this._main.scenes[ViewType.AP].cameraControls.fitToPlane();
			if (this._main.hasLT) this._main.scenes[ViewType.LT].cameraControls.fitToPlane();
		}

		if (stateType >= StateTypes.deformityAnalysis && (bindedModel.isMechanicalAxisAPValid || bindedModel.isMechanicalAxisLTValid || bindedModel.isControlateralMechanicalAxisValid)) {
			this._main.rotateCamera(RotateCameraType.none);
			printResult.deformity = this.generateImage(PrintStateTypes.deformityAnalysis);
		}

		if (stateType >= StateTypes.EOC && bindedModel.EOCCropVisible) {
			if (stateType === StateTypes.templating) this._main.rotateCamera(RotateCameraType.templating);
			printResult.templating = this.generateImage(PrintStateTypes.defAnalysisNext);
		}

		this.restoreData(tempData);

		return printResult;
	}
}
